import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TrackingUtilities = /*#__PURE__*/function () {
  function TrackingUtilities() {
    _classCallCheck(this, TrackingUtilities);
  }
  return _createClass(TrackingUtilities, null, [{
    key: "derivePageTitle",
    value: function derivePageTitle(pathname) {
      var pageTitle = pathname.replace(/.*\/(.+)/, '$1');
      pageTitle = pageTitle.toLowerCase().replace(/(^| )(\w)/g, function (s) {
        return s.toUpperCase();
      });
      return pageTitle;
    }
  }, {
    key: "initDigitalData",
    value: function initDigitalData() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var pageName = (window.location.host + window.location.pathname).replace(/\//g, ':');
      if (pageName.lastIndexOf(':') === pageName.length - 1) {
        pageName = pageName.substring(0, pageName.length - 1);
      }
      var friendlyPageName = "".concat(pageName, ":").concat(title || document.title).replace(/:$/, '');
      var pageData = {
        pageName: pageName,
        prevPageName: '',
        friendlyPageName: friendlyPageName,
        country: 'AU',
        environment: process.env.NODE_ENV || 'production',
        domain: window.location.hostname,
        language: 'en-AU',
        webAppName: 'Qantas Shopping Earn'
      };
      window.digitalData = {
        events: [],
        page: {
          pageInfo: pageData
        },
        user: {
          loggedIn: false,
          id: ''
        }
      };
    }
  }, {
    key: "trackPageView",
    value: function trackPageView() {
      var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var ctx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      try {
        var _window$digitalData, _window$digitalData$p, _window$digitalData$p2;
        var pageName = (window.location.host + window.location.pathname).replace(/\//g, ':');
        if (pageName.lastIndexOf(':') === pageName.length - 1) {
          pageName = pageName.substring(0, pageName.length - 1);
        }
        var pageTitle = title || this.derivePageTitle(window.location.pathname);
        var friendlyPageName = "".concat(pageName, ":").concat(pageTitle).replace(/:$/, '');
        var pageData = _objectSpread({
          pageName: pageName,
          prevPageName: (_window$digitalData = window.digitalData) === null || _window$digitalData === void 0 ? void 0 : (_window$digitalData$p = _window$digitalData.page) === null || _window$digitalData$p === void 0 ? void 0 : (_window$digitalData$p2 = _window$digitalData$p.pageInfo) === null || _window$digitalData$p2 === void 0 ? void 0 : _window$digitalData$p2.pageName,
          friendlyPageName: friendlyPageName,
          environment: process.env.NODE_ENV || 'production',
          domain: window.location.hostname,
          language: 'en-AU',
          webAppName: 'Qantas Shopping Earn'
        }, ctx);
        var windowData = window.digitalData.page.pageInfo;
        window.digitalData.page.pageInfo = _objectSpread(_objectSpread({}, windowData), pageData);
        if (window.digitalData.events.length > 1) {
          window.digitalData.events.splice(0, window.digitalData.events.length - 1);
        }
        // Below is needed otherwise the parameter isn't sent to Adobe (unsolvable adobe bug.)
        window.digitalData.events.push({
          category: 'analytics',
          eventInfo: {
            eventName: 'Pre-Pageload'
          }
        });
        window.digitalData.events.push({
          category: 'analytics',
          eventInfo: {
            eventName: 'Page Load',
            cause: document.body,
            eventAction: 'load',
            context: {
              cust_pageView: 1,
              cust_pageName: pageName
            }
          }
        });
      } catch (e) {
        // console.error("tracking error", e) - may activate in the future
        this.initDigitalData('');
        this.trackPageView(title, ctx);
      }
    }
  }, {
    key: "updatePageInfo",
    value: function updatePageInfo(newData) {
      var windowData = window.digitalData && window.digitalData.page && window.digitalData.page.pageInfo ? window.digitalData.page.pageInfo : {};
      try {
        window.digitalData.page.pageInfo = _objectSpread(_objectSpread({}, windowData), newData);
      } catch (e) {
        this.initDigitalData('');
        this.updatePageInfo(newData);
      }
    }
  }, {
    key: "trackLogin",
    value: function trackLogin(memberHash) {
      if (memberHash && window.digitalData && window.digitalData.user && !window.digitalData.user.loggedIn) {
        window.digitalData.user = {
          id: memberHash,
          loggedIn: true,
          eVar20: 'hard'
        };
        window.digitalData.events.push({
          uAction: 'QCardOffersAUlogin'
        });
      }
    }
  }, {
    key: "trackSoftLogin",
    value: function trackSoftLogin() {
      if (window.digitalData && window.digitalData.user && !window.digitalData.user.loggedIn) {
        window.digitalData.user = {
          id: '',
          loggedIn: false,
          eVar20: 'soft'
        };
        window.digitalData.events.push({
          uAction: 'QCardOffersAUlogin'
        });
      }
    }
  }, {
    key: "trackLogout",
    value: function trackLogout() {
      if (window.digitalData) {
        window.digitalData.user = {
          loggedIn: false
        };
      }
    }
  }, {
    key: "trackLoginError",
    value: function trackLoginError(err) {
      if (window.digitalData && window.digitalData.events) {
        window.digitalData.events.push({
          uAction: 'QCardOffersAUerrorMessage',
          uActionContext: {
            errorCode: '',
            errorCategory: err.errorMessage,
            errorDescription: err.errorMessage
          }
        });
      }
    }
  }, {
    key: "trackGenericAction",
    value: function trackGenericAction(action, context) {
      try {
        window.digitalData.events.push({
          uAction: action,
          uActionContext: context
        });
      } catch (e) {
        this.initDigitalData('');
        this.trackGenericAction(action, context);
      }
    }
  }]);
}();
export default TrackingUtilities;